import { render, staticRenderFns } from "./WholesalePos.vue?vue&type=template&id=173e4966&scoped=true&"
import script from "./WholesalePos.vue?vue&type=script&lang=js&"
export * from "./WholesalePos.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./WholesalePos.vue?vue&type=style&index=1&id=173e4966&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173e4966",
  null
  
)

export default component.exports